import React from 'react'
import ReactDOM from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'

import './index.css'

import App from './App'
import { TenantProvider } from './providers/TenantProvider'

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
  },
])

const root = ReactDOM.createRoot(document.getElementById('root')!)

const tokenFromUrl = new URLSearchParams(window.location.search).get('token')

root.render(
  <React.StrictMode>
    <TenantProvider token={tokenFromUrl}>
      <RouterProvider router={router} />
    </TenantProvider>
  </React.StrictMode>,
)
